export default {"src":"/_next/static/media/sandclock.9038b2d3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};